import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// ✅ Pre-initialize MSAL so it avoids the uninitialized error
await msalInstance.initialize();